<template>
  <v-app>
    <v-main>
      <v-container class="py-5">
        <v-row justify="center">
          <v-col xs="8" sm="6" md="4" lg="4" class="mb-3 mx-4">
            <v-responsive>
              <v-img src="https://rayoga.com/wp-content/uploads/2022/12/ra-yoga-logo-1.svg" />
            </v-responsive>
          </v-col>
        </v-row>
      </v-container>
      <router-view/>
      <v-progress-linear
        :value="timer"
        color="primary"
        height="20"
        absolute
        bottom
      ></v-progress-linear>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),

  computed: {
    timer() {
      return this.$store.state.timerDisplay
    },
  },

  methods: {
  },

  mounted() {
  },
}
</script>

<style>
.grecaptcha-badge { visibility: hidden; }

.v-sheet {
  border-radius: 15px;
}

.v-main[style] {
  background: #F8F4EF;
  font-family: Gopher;
  background-size: cover;
}

.v-main__wrap {
  background: #F8F4EF;
  padding-top: 20px;
  padding-bottom: 20px;
}

@media(max-width: 1100px) {
  .v-main[style] {
    background-color: #F8F4EF;
  }

  .v-main__wrap {
    background: transparent;
  }
}
</style>
